<template>
  <div id="mb-game" :key="componentKey">
    <div
      id="mb-game-scalable"
      class="mb-game-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
      }"
      @click="onMouseMove($event)"
    >
      <img class="main-img" :src="bcg" v-if="bcg" />
      <div
        :style="{ top: cl.top + '%', left: cl.left + '%', display: cl.display }"
        class="click-effect"
        style="width: 48px; height: 48px; position: absolute; background: transparent"
        v-for="(cl, clickIndex) in click"
        :key="'click-effect-id-' + clickIndex"
      >
        <div style="position: relative; width: 100%; height: 100%">
          <img
            draggable="false"
            class="click-effect-img"
            v-for="(clickImg, clickImgIndex) in cl.images"
            :key="'click-id-' + clickImgIndex"
            :src="clickImg"
            :style="{ animationDelay: 0.05 * clickImgIndex + 's' }"
            style="z-index: 4; width: 48px; height: 48px; position: absolute; top: 0; left: 0; opacity: 0"
          />
        </div>
      </div>
      <mb-title
        v-if="titleData.text != '' && avatar"
        :title="titleData.text"
        :audio="titleData.audio"
        :icon="avatar.smallAvatar"
        style="z-index: 5"
      ></mb-title>
      <mb-game-controll-panel
        :file="fileData"
        :prevroute="prevRoute"
        @nextGame="nextGame"
        @prvGame="prvGame"
        style="z-index: 5"
      ></mb-game-controll-panel>
      <!-- <div id="game-container" class="game-container"> -->
      <component
        :is="componentEngine"
        :start-game-config="gameConfig"
        :assets="assets"
        :game-id="gameData.id"
      ></component>
      <mb-game-status
        v-if="avatar && checkGameObj()"
        :icon="avatar.bigAvatar"
        :gif="avatar.gif"
        :success-gif="avatar.successGif"
        :success-icon="avatar.successIcon"
        :game-check-switch-style="avatar.gameCheckSwitchStyle"
        :communication="avatar.communication"
        style="z-index: 5"
      ></mb-game-status>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import MbGameControllPanel from './MbGameControllPanel/MbGameControllPanel';
import MbTitle from './MbTitle/MbTitle';
import MbGameStatus from './MbGameStatus/MbGameStatus';
//GAMES
import TrTestMulti from '__mainSrcDir/components/TrGame/v4/GameEngines/TestMulti/TrTestMulti';
import TrTestMultiCheckboxImpr from '__mainSrcDir/components/TrGame/v4/GameEngines/TestMulti/TrTestMultiCheckboxImpr';
import TrMultiCheckbox from '__mainSrcDir/components/TrGame/v4/GameEngines/TestMulti/TrMultiCheckbox';
import TrMultiCheckboxImpr from '__mainSrcDir/components/TrGame/v4/GameEngines/TestMulti/TrMultiCheckboxImpr';
import TrTestBoolean from '__mainSrcDir/components/TrGame/v4/GameEngines/TestBoolean/TrTestBoolean';
import TrTextBlockWithInput from '__mainSrcDir/components/TrGame/v4/GameEngines/TextBlockWithInput/TrTextBlockWithInput';
import TrTextBlockWithInputImpr from '__mainSrcDir/components/TrGame/v4/GameEngines/TextBlockWithInput/TrTextBlockWithInputImpr';
import TrInputOnBackground from '__mainSrcDir/components/TrGame/v4/GameEngines/InputOnBackground/TrInputOnBackground';
import TrInputOnBackgroundWithoutCheck from '__mainSrcDir/components/TrGame/v4/GameEngines/InputOnBackground/TrInputOnBackgroundWithoutCheck';
import TrTestSelectGame from '__mainSrcDir/components/TrGame/v4/GameEngines/SelectGame/TrTestSelectGame';
import TrSelectGameWithText from '__mainSrcDir/components/TrGame/v4/GameEngines/SelectGame/TrSelectGameWithText';
import TrSelectImage from '__mainSrcDir/components/TrGame/v4/GameEngines/SelectImage/TrSelectImage';
import TrSelectGame from '__mainSrcDir/components/TrGame/v4/GameEngines/SelectGame/TrSelectGame';
import TrTextAreaOnBackground from '__mainSrcDir/components/TrGame/v4/GameEngines/TextAreaOnBackground/TrTextAreaOnBackground';
import TrSelectGameWithTextImpr from '__mainSrcDir/components/TrGame/v4/GameEngines/SelectGame/TrSelectGameWithTextImpr';
import TrStepByStep from '__mainSrcDir/components/TrGame/v4/GameEngines/StepByStep/TrStepByStep';
import TrStepByStepComics from '__mainSrcDir/components/TrGame/v4/GameEngines/StepByStep/TrStepByStepComics';
//MB
import TrCroppImg from '__mainSrcDir/components/TrGame/v4/GameEngines/MbCroppImg/MbCroppImg';
import TrPuzzle from '__mainSrcDir/components/TrGame/v4/GameEngines/MbPuzzle/MbPuzzle';
import TrBalloonsGame from '__mainSrcDir/components/TrGame/v4/GameEngines/MbBalloonsGame/MbBalloonsGame';
import TrImageSelect from '__mainSrcDir/components/TrGame/v4/GameEngines/MbImageSelect/MbImageSelect';
import TrMemory from '__mainSrcDir/components/TrGame/v4/GameEngines/MbMemory/MbMemory';
import TrTestWithPoints from '__mainSrcDir/components/TrGame/v4/GameEngines/MbTestWithPoints/MbTestWithPoints';
import TrSteps from '__mainSrcDir/components/TrGame/v4/GameEngines/MbSteps/MbSteps';
import MbListenAndPoint from '__mainSrcDir/components/TrGame/v4/GameEngines/MbListenAndPoint/MbListenAndPoint';
import MbDecisionTree from '__mainSrcDir/components/TrGame/v4/GameEngines/MbDecisionTree/MbDecisionTree';
import MbRoulette from '__mainSrcDir/components/TrGame/v4/GameEngines/MbRoulette/MbRoulette';
import MbQuiz from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuiz/MbQuiz';
import MbQuizWithBorder from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuiz/MbQuizWithBorder';
import MbCoding from '__mainSrcDir/components/TrGame/v4/GameEngines/MbCoding/MbCoding';
import MbTest from '__mainSrcDir/components/TrGame/v4/GameEngines/MbTest/MbTest';
import MbPathChecker from '__mainSrcDir/components/TrGame/v4/GameEngines/MbPathChecker/MbPathChecker';
import MbMonograph from '../../MbMonograph/MbMonograph';
import MbFilm from '__mainSrcDir/components/TrGame/v4/GameEngines/MbFilm/MbFilm';
import MbQuestion from '__mainSrcDir/components/TrGame/v4/GameEngines/MbQuestion/MbQuestion';
import MbDragAndDrop from '__mainSrcDir/components/TrGame/v4/GameEngines/MbDragAndDrop/MbDragAndDrop';
import MbGallery from '__mainSrcDir/components/TrGame/v4/GameEngines/MbGallery/MbGallery';
// MZ
import MzAudio from '__mainSrcDir/components/TrGame/v4/GameEngines/MzAudio/MzAudio';
import MzColoring from '__mainSrcDir/components/TrGame/v4/GameEngines/MzColoring/MzColoring';
import MzLabyrinth from '__mainSrcDir/components/TrGame/v4/GameEngines/MzLabyrinth/MzLabyrinth';
import MzLabyrinth2 from '__mainSrcDir/components/TrGame/v4/GameEngines/MzLabyrinth/MzLabyrinth2';
import MzKaraoke from '__mainSrcDir/components/TrGame/v4/GameEngines/MzKaraoke/MzKaraoke';
// VUE
import MpChooseAnswer from '__mainSrcDir/components/TrGame/v4/GameEngines/MpChooseAnswer/MpChooseAnswer';
import MpChooseAnswer16 from '__mainSrcDir/components/TrGame/v4/GameEngines/MpChooseAnswer/MpChooseAnswer16';
import MpChooseAnswer04 from '__mainSrcDir/components/TrGame/v4/GameEngines/MpChooseAnswer/MpChooseAnswer04';
import MpCrossword from '__mainSrcDir/components/TrGame/v4/GameEngines/MpCrossword/MpCrossword';
import MpCrossword2 from '__mainSrcDir/components/TrGame/v4/GameEngines/MpCrossword/MpCrossword2';
import MpFindWords from '__mainSrcDir/components/TrGame/v4/GameEngines/MpFindWords/MpFindWords';
import MpFindWordsByClick from '__mainSrcDir/components/TrGame/v4/GameEngines/MpFindWords/MpFindWordsByClick';
import MpGalleryFade from '__mainSrcDir/components/TrGame/v4/GameEngines/MpGallery/MpGalleryFade';
import MpGallerySvgAnime from '__mainSrcDir/components/TrGame/v4/GameEngines/MpGallery/MpGallerySvgAnime';
// import MpGallerySvgSnap from './GameEngines/MpGallery/MpGallerySvgSnap';
import MpMendelejew from '__mainSrcDir/components/TrGame/v4/GameEngines/MpMendelejew/MpMendelejew';
import MpMillionaires from '__mainSrcDir/components/TrGame/v4/GameEngines/MpMillionaires/MpMillionaires';
import MpModelShow from '__mainSrcDir/components/TrGame/v4/GameEngines/MpModel3d/MpModel3d';
import MpTextSelect from '__mainSrcDir/components/TrGame/v4/GameEngines/MpTextSelect/MpTextSelect';
// CREATE JS
import MpCreateJS from '__mainSrcDir/components/TrGame/v4/GameEngines/MpCreateJS/MpCreateJS';
import _ from 'lodash';
export default {
  name: 'mb-game',
  components: {
    MbGameControllPanel,
    MbTitle,
    MbGameStatus,
    //GAMES:
    TrTestMulti,
    TrTestMultiCheckboxImpr,
    TrTestBoolean,
    TrTextBlockWithInput,
    TrInputOnBackground,
    TrInputOnBackgroundWithoutCheck,
    TrTestSelectGame,
    TrSelectGameWithText,
    TrSelectImage,
    MpFindWords,
    MpFindWordsByClick,
    MpModelShow,
    MpTextSelect,
    MpChooseAnswer,
    MpChooseAnswer16,
    MpChooseAnswer04,
    MpCrossword,
    MpCrossword2,
    MpMillionaires,
    MpMendelejew,
    MpGalleryFade,
    MpGallerySvgAnime,
    // MpGallerySvgSnap,
    MpCreateJS,
    TrSelectGame,
    TrMultiCheckbox,
    TrMultiCheckboxImpr,
    TrTextBlockWithInputImpr,
    TrTextAreaOnBackground,
    TrSelectGameWithTextImpr,
    TrStepByStep,
    TrTestWithPoints,
    TrStepByStepComics,
    TrCroppImg,
    TrBalloonsGame,
    TrImageSelect,
    TrMemory,
    MbListenAndPoint,
    MbDecisionTree,
    MbRoulette,
    MbQuiz,
    MbQuizWithBorder,
    MbCoding,
    MbTest,
    MbPathChecker,
    MbMonograph,
    MbFilm,
    MbQuestion,
    MbDragAndDrop,
    MbGallery,
    //
    TrSteps,
    TrPuzzle,
    MzAudio,
    MzColoring,
    MzLabyrinth,
    MzLabyrinth2,
    MzKaraoke,
  },
  data: function () {
    return {
      componentKey: 0,
      bcg: null,
      showGame: false,
      balls: [],
      top: 0,
      left: 0,
      clickerPath: [
        'M 41.40,42.20\
        C 41.40,42.20 50.10,14.50 50.10,14.50\
        50.10,14.50 59.00,41.80 59.00,41.80\
        59.00,41.80 87.30,42.00 87.30,42.00\
        87.30,42.00 64.60,58.70 64.60,58.70\
        64.60,58.70 73.20,86.10 73.20,86.10\
        73.20,86.10 50.00,69.00 50.00,69.00\
        50.00,69.00 27.10,86.20 27.10,86.20\
        27.10,86.20 36.00,58.90 36.00,58.90\
        36.00,58.90 12.40,41.80 12.40,41.80\
        12.40,41.80 41.30,41.90 41.30,41.90',
        'M 50.40,6.00\
        C -5.70,6.60 -8.55,92.70 49.80,93.30\
        106.95,93.45 106.37,7.14 50.55,6.15M 56.85,93.45',
        'M 50.10,14.85\
        C 50.10,14.85 13.05,42.45 13.20,42.45\
        13.35,42.45 26.40,85.35 26.55,85.35\
        26.70,85.35 73.05,85.95 73.05,85.95\
        73.05,85.95 86.70,42.60 86.70,42.60\
        86.70,42.60 50.25,15.00 50.25,15.00',
        'M 50.55,13.20\
        C 50.70,13.20 13.50,86.25 13.50,86.25\
        13.50,86.25 86.25,86.25 86.25,86.25\
        86.25,86.25 50.25,13.65 50.25,13.65',
        'M 49.80,6.60\
        C 49.80,6.60 6.90,49.80 6.90,49.80\
        6.90,49.80 49.80,93.30 49.80,93.30\
        49.80,93.30 93.00,49.80 93.00,49.80\
        93.00,49.80 49.80,6.60 49.80,6.60',
        'M 6.90,6.60\
        C 6.90,6.60 93.00,6.60 93.00,6.60\
        93.00,6.60 55.20,49.80 55.20,49.80\
        55.20,49.80 93.00,93.30 93.00,93.30\
        93.00,93.30 6.90,93.30 6.90,93.30\
        6.90,93.30 45.75,49.80 45.75,49.80\
        45.75,49.80 6.90,6.60 6.90,6.60',
        'M 40.10,6.60\
        C 40.10,6.60 59.80,6.60 59.80,6.60\
        59.80,6.60 60.30,40.00 60.30,40.00\
        60.30,40.00 93.00,40.00 93.00,40.00\
        93.00,40.00 93.00,60.00 93.00,60.00\
        93.00,60.00 60.20,60.10 60.20,60.10\
        60.20,60.10 60.00,93.30 60.00,93.30\
        60.00,93.30 39.90,93.30 40.00,93.30\
        40.10,93.30 40.60,60.50 40.60,60.50\
        40.60,60.50 6.90,60.30 6.90,60.30\
        6.90,60.30 6.90,39.70 6.90,39.70\
        6.90,39.70 39.80,39.90 39.80,39.90\
        39.80,39.90 40.10,6.60 40.10,6.60',
        'M 73.35,6.60\
        C 73.35,6.60 93.00,26.70 93.00,26.70\
        93.00,26.70 93.00,46.80 93.00,46.80\
        93.00,46.80 49.80,93.30 49.80,93.30\
        49.80,93.30 6.90,46.20 6.90,46.20\
        6.90,46.20 6.90,26.85 6.90,26.85\
        6.90,26.85 27.00,6.60 27.00,6.60\
        27.00,6.60 73.20,6.60 73.20,6.60',
      ],
      clickerIndex: 0,
      clickItems: [],
      titleIcons: [],
      titleData: {
        text: '',
        audio: '',
      },
      click: [],
      fileData: [],
      scaleW: 1,
      scaleH: 1,
      scale: 1,
      prevRoute: null,
      avatar: null,
      canIBall: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      // console.log(from);
    });
  },
  beforeMount() {
    this.init();
  },
  mounted() {
    this.scaleW = this.setWidthScale();
    this.scaleH = this.setHeightScale();
    this.resizeWindow();
    this.mountedInit();
    //DYNAMIC MAIN IMG
    // if (this.gameBcgConf && this.gameLevel) {
    //   this.gameBcgConf.forEach((it) => {
    //     if (it.id == this.gameLevel) {
    //       let tmp = this.shuffle(it.bcg);
    //       this.bcg = tmp[0];
    //       console.log('HI');
    //       this.$store.commit('SET_GAME_COLOR', it.color);
    //     }
    //   });
    // }
  },
  created() {
    window.addEventListener('resize', this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  methods: {
    nextGame() {
      if (this.currentStage + 1 < this.stages.length) {
        this.$router.push(`/game/by/id/${this.stages[this.currentStage + 1]}`);
        let gameObj = this.$store.getters[`${_.upperFirst(this.$store.getters.multibookType)}/gameByID`](
          this.stages[this.currentStage + 1]
        );
        console.log('gameObj', gameObj);
        this.$store.dispatch('newGame', gameObj);
        this.$store.commit('CHANGE_CURRENT_STAGE', this.currentStage + 1);
        this.forceRerender();
      }
    },
    prvGame() {
      if (this.currentStage > 0) {
        this.$router.push(`/game/by/id/${this.stages[this.currentStage - 1]}`);
        let gameObj = this.$store.getters[`${_.upperFirst(this.$store.getters.multibookType)}/gameByID`](
          this.stages[this.currentStage - 1]
        );
        console.log('gameObj', gameObj);
        this.$store.dispatch('newGame', gameObj);
        this.$store.commit('CHANGE_CURRENT_STAGE', this.currentStage - 1);
        this.forceRerender();
      }
    },
    forceRerender() {
      this.componentKey += 1;
      this.mountedInit();
    },
    mountedInit() {
      if (this.gameData.item.title) {
        this.titleData.text = this.gameData.item.title[0].text;
        this.titleData.audio = this.gameData.item.title[0].audio;
      }
      if (this.gameData.item.file) {
        this.fileData = this.gameData.item.file;
      }
      if (this.gameData.item.avatar) {
        this.avatar = _.cloneDeep(
          this.titleIcons[this.titleIcons.findIndex((i) => i.id === this.gameData.item.avatar)]
        );
        // console.log(this.avatar);
      } else {
        this.avatar = _.cloneDeep(this.titleIcons[0]);
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    onMouseMove(e) {
      if (this.canIBall) {
        this.canIBall = false;
        let rect = document.getElementById('mb-game-scalable').getBoundingClientRect();
        let posX = e.clientX - rect.left;
        let posY = e.clientY - rect.top;
        // console.log(rect);
        let left = ((posX - 24) / rect.width) * 100;
        let top = ((posY - 24) / rect.height) * 100;
        this.clickerIndex = this.randomNumber(8, 0);
        // this.createBalls(10, top, left);
        this.clickEffect(top, left);
        setTimeout(() => {
          this.canIBall = true;
        }, 100);
        // console.log(this.left - 50 + ' : ' + this.top - 50);
      }
    },
    onTouchEnd(e) {
      console.log(e);
      if (this.canIBall) {
        this.canIBall = false;
        let rect = document.getElementById('mb-game-scalable').getBoundingClientRect();
        let posX = e.targetTouches[0].clientX - rect.left;
        let posY = e.targetTouches[0].clientY - rect.top;
        // console.log(rect);
        let left = ((posX - 24) / rect.width) * 100;
        let top = ((posY - 24) / rect.height) * 100;
        // this.createBalls(10, top, left);
        this.clickEffect(top, left);
        setTimeout(() => {
          this.canIBall = true;
        }, 100);
        // console.log(this.left - 50 + ' : ' + this.top - 50);
      }
    },
    clickEffect(t, l) {
      let clickNumber = this.click.length;
      this.click.push({ images: this.clickItems, left: l, top: t, display: 'block' });
      setTimeout(() => {
        this.click[clickNumber].display = 'none';
      }, 50 * this.clickItems.length);
    },
    createBalls(n, t, l) {
      let tmpBalls = [];
      let clickNumber = this.balls.length;
      for (let i = 0; i < n; i++) {
        tmpBalls.push({
          color: this.getRandomColor(),
          width: this.randomNumber(30, 5),
          opacity: 0,
          transitionDuration: this.randomNumber(30, 0) / 100,
          transitionDelay: this.randomNumber(30, 0) / 100,
          top: this.randomNumber(10, 45),
          left: this.randomNumber(10, 45),
          rotate: this.randomNumber(360, 0),
        });
      }
      this.balls.push({ ball: tmpBalls, left: l, top: t, display: 'block' });
      setTimeout(() => {
        for (let i = 0; i < n; i++) {
          if (this.balls[clickNumber].ball[i].top > 50) {
            this.balls[clickNumber].ball[i].top = this.balls[clickNumber].ball[i].top + this.randomNumber(50, 20);
          } else {
            this.balls[clickNumber].ball[i].top = this.balls[clickNumber].ball[i].top - this.randomNumber(50, 20);
          }
          if (this.balls[clickNumber].ball[i].left > 50) {
            this.balls[clickNumber].ball[i].left = this.balls[clickNumber].ball[i].left + this.randomNumber(50, 20);
          } else {
            this.balls[clickNumber].ball[i].left = this.balls[clickNumber].ball[i].left - this.randomNumber(50, 20);
          }
          this.balls[clickNumber].ball[i].opacity = 0.7;
          this.balls[clickNumber].ball[i].rotate = this.randomNumber(360, 0);
          setTimeout(() => {
            this.balls[clickNumber].ball[i].opacity = 0;
            // this.balls[clickNumber].ball[i].rotate = this.randomNumber(360, 0);
            setTimeout(() => {
              this.balls[clickNumber].display = 'none';
            }, 1000);
            // console.log((this.balls[i].transitionDuration + this.balls[i].transitionDelay) * 1000);
          }, (this.balls[clickNumber].ball[i].transitionDuration + this.balls[clickNumber].ball[i].transitionDelay) * 1000);
        }
      }, 50);
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    checkGameObj() {
      if (this.gameConfig) {
        if (this.gameConfig.withoutCheck) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
    resizeWindow(e) {
      let itm = document.getElementById('mb-game').getBoundingClientRect();
      this.scale = Math.min(itm.width / 1920, itm.height / 1080);
    },
    setWidthScale() {
      let itm = document.getElementById('mb-game').getBoundingClientRect();
      // console.log(itm);
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-game').getBoundingClientRect();
      // console.log(itm);
      return itm.height / 1080;
    },
    init() {
      try {
        this.clickItems = require('__mainSrcDir/config/gridViewConfigs/click/click.config.js').default;
      } catch {
        console.log('%cClickConfig - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      try {
        this.titleIcons = require('__mainSrcDir/config/gridViewConfigs/gameInterface/game.config.js').default;
      } catch {
        console.log(
          '%cgameInterface (titleIcons) - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      if (!this.gameData.item) {
        this.$router.push(`/`);
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch {
        console.log('%cImgPath - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
    },
  },
  computed: {
    stages() {
      return this.$store.getters.stages;
    },
    currentStage() {
      return this.$store.getters.currentStage;
    },
    componentEngine() {
      let author = this.gameData.item.author || 'TR';
      author = _.chain(author).toLower().upperFirst().value();
      return this.gameData.item.engine.replace(/^\w{0,1}/, function (a) {
        return `${author}${a.toUpperCase()}`;
      });
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    gameLevel() {
      return this.$store.getters.getGameLevel;
    },
    gameConfig() {
      return _.cloneDeep(Object.assign({}, this.gameData.item.gameConfig, { gamePath: this.gameData.item.gamePath }));
    },
    assets() {
      return _.cloneDeep(this.gameData.item.assets);
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
#mb-game
  width: 100vw
  height: calc(var(--vh, 1vh) * 100)
  // background: #ffd100
  overflow: hidden
  background: white
  resize: both
  .mb-game-scalable
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    background: white
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
    .main-img
      width: 1920px
      height: 1080px
      position: absolute
      top: 0
      left: 0
    .click-effect-img
      animation: .05s 0s clickImg 1 linear forwards

@keyframes clickImg
  0%
    opacity: 1
  99%
    opacity: 1
  100%
    opacity: 0
</style>
